// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  config: {
    authorizeNetClientKey: '56RE6433SCLfeWK67pwGmKj2wH2mPypHhSz888XU87kbSxYu26bWWgzq8TKQbDdJ',
    authorizeNetApiLoginId: '8F35fXt4',
    // Default to sandbox for local/dev
    authorizeNetTestRequest: true,
    API_BASE_URL: '/content',
    ASSET_BASE_URL: '/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
